/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointmentCalendarSettings = sqliteTable('appointment_calendar_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  filter_category_enabled: integer('filter_category_enabled'),
  filter_status_enabled: integer('filter_status_enabled'),
  filter_provider_enabled: integer('filter_provider_enabled'),
  filter_service_enabled: integer('filter_service_enabled'),
  filter_room_enabled: integer('filter_room_enabled'),
  filter_location_enabled: integer('filter_location_enabled'),
  default_view: text('default_view'),
  week_starts_on: text('week_starts_on'),
  working_hours_start_min: integer('working_hours_start_min'),
  working_hours_end_min: integer('working_hours_end_min'),
  slot_interval_min: integer('slot_interval_min'),
  color_appointments_by: text('color_appointments_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
